module.exports = __webpack_public_path__ + "img/crown_2.93ecc5c2.svg";